module.exports = __webpack_public_path__ + "static/img/cor-zhyq.9c8cfcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cor-zhyq.png
// module id = 6zZU
// module chunks = 0